import { withInstall } from '@xzx-design/utils'
import _Stepper from './src/stepper'

export const Stepper = withInstall(_Stepper)
export default Stepper

export * from './src/stepper'
